import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { atom } from "recoil";

export const Render_edit_cell = (toggle_TypeOfPortal, setToggleTypeOfPortal, getloadfun, title,TableSelectionData) => {
  // console.log(toggle_TypeOfPortal, "TypeOfPortal6")
  const dispatch = useDispatch();
  // const [{ currentPath, previousPath, PerviousTitle, CurrentTitle }] = useRecoilState(pathState);
  let ParentPortalCloseFunction = () => {
    // console.log(toggleState);
    setToggleTypeOfPortal((prev) => ({ ...prev, toggle: false }));
    dispatch({ type: "CLEAR_COMPONENT_PROP" });
  };

  // const [{ CurrentTitle }] = useRecoilState(pathState);
  let component_props = {
    show: toggle_TypeOfPortal?.toggle,
    TypeOfPortal: toggle_TypeOfPortal?.TypeOfPortal || "Edit",
    submitType: toggle_TypeOfPortal?.TypeOfPortal,
    invokeform: getloadfun,
    ParentPortalCloseFunction: ParentPortalCloseFunction,
    tableClick: true,
    Type:TableSelectionData?. Selected_Row?.Type
  };
  // console.log(title,component_props, "titletitletitletitle");
  useEffect(() => {
    if (toggle_TypeOfPortal?.toggle) {
      dispatch({
        type: "SET_COMPONENT_PROP",
        payload: { Table_Key: title, props: component_props },
      });
    }
  }, [toggle_TypeOfPortal?.toggle]);
};

const scrollActiveCellIntoViewVertically = (newRowIndex, tableContainerRef, activeCellCoords) => {
  const activeCellElement = document.querySelector(`.table-container table tbody tr:nth-child(${newRowIndex + 1})`);
  if (activeCellElement) {
    const container = tableContainerRef.current;
    const scrollPosition = activeCellElement.offsetTop - container.offsetTop;
    const maxScrollPosition = container.scrollHeight - container.clientHeight;
    container.scrollTop = Math.min(scrollPosition, maxScrollPosition);
  }
};

const scrollActiveCellIntoViewHorizontal = (newColIndex, tableContainerRef, activeCellCoords) => {
  const activeCellElement = document.querySelector(
    `.table-container table tbody tr:nth-child(${activeCellCoords.rowIndex + 1}) td:nth-child(${newColIndex})`
  );

  if (activeCellElement) {
    const container = tableContainerRef.current;
    const scrollPosition = activeCellElement.offsetLeft - container.offsetLeft;
    const maxScrollPosition = container.scrollWidth - container.clientWidth;
    container.scrollLeft = Math.min(scrollPosition, maxScrollPosition);
  }
};
export const handleKeyDown1 = (
  event,
  toggleState,
  activeCellCoords,
  tableCols,
  rows,
  tableData,
  getloadfun,
  setActiveCellCoords,
  setActiveCell,
  tableContainerRef
) => {
  event.stopPropagation();

  if (toggleState) return;

  let newRowIndex = activeCellCoords.rowIndex;
  let newColIndex = tableCols.indexOf(activeCellCoords.colKey);

  // if (event.keyCode === 32) {
  //   event.preventDefault();
  //   const row = rows[newRowIndex];
  //   row.toggleSelected(!row.getIsSelected());
  //   return;
  // }

  switch (event.key) {
    case "ArrowUp":
      newRowIndex = Math.max(0, newRowIndex - 1);
      scrollActiveCellIntoViewVertically(newRowIndex, tableContainerRef, activeCellCoords);
      break;

    case "ArrowDown":
      newRowIndex = Math.min(tableData.length - 1, newRowIndex + 1);
      scrollActiveCellIntoViewVertically(newRowIndex, tableContainerRef, activeCellCoords);
      break;

    case "ArrowLeft":
      newColIndex = Math.max(0, newColIndex - 1);
      scrollActiveCellIntoViewHorizontal(newColIndex, tableContainerRef, activeCellCoords);
      break;

    case "ArrowRight":
      newColIndex = Math.min(tableCols.length - 1, newColIndex + 1);
      scrollActiveCellIntoViewHorizontal(newColIndex, tableContainerRef, activeCellCoords);
      break;

    case "Enter":
      // getloadfun(rows[newRowIndex]);
      return;

    default:
      return;
  }

  setActiveCellCoords({
    rowIndex: newRowIndex,
    colKey: tableCols[newColIndex],
  });
  setActiveCell(`${newRowIndex}_${tableCols[newColIndex]}`);
};
const atomRegistry = new Map();
export const AtomstateCallback = (title) => {
  if (!atomRegistry.has(title)) {
    const newAtom = atom({
      key: title,
      default: {},
    });
    atomRegistry.set(title, newAtom);
    return newAtom;
  } else {
    return atomRegistry.get(title);
  }
};

export const AtomstateCallbackFilter = (title) => {
  if (!atomRegistry.has(title)) {
    const newAtom = atom({
      key: title,
      default: [],
    });
    atomRegistry.set(title, newAtom);
    return newAtom;
  } else {
    return atomRegistry.get(title);
  }
};
export function extractIds(dataArray) {
  return dataArray?.map((item) => item?._id || item?.id);
}

export const GetTableHeaders = ({ tableData, TableHeaders }) => {
  if (!tableData || tableData.length === 0) return [];

  // keys in the exact order we want for the table
  const keys = Object.keys(tableData[0]);

  // quick lookup: key → full header row (["Date","Date",null,true])
  const headerMap = new Map(TableHeaders.map((row) => [row[0], row]));

  // build the final list in the right order
  const orderedHeaders = keys.map(
    (key) => headerMap.get(key) ?? [key, key] // reuse existing row or add default
  );
  console.log({ orderedHeaders, headerMap, keys }, "orderedHeadersorderedHeadersorderedHeaders");
  return orderedHeaders;
};
// export const GetTableHeaders = ({ tableData, TableHeaders }) => {
//   if (!tableData || tableData.length === 0) return [];

//   const keys = Object.keys(tableData[0]).map(k => k.trim());

//   const headerMap = new Map(
//     TableHeaders.map(([key, ...rest]) => [key.trim(), [key.trim(), ...rest]])
//   );

//   const orderedHeaders = keys.map(key =>
//     headerMap.get(key) ?? [key, key]
//   );

//   console.log({ orderedHeaders, headerMap, keys }, "orderedHeaders");

//   return orderedHeaders;
// };
